import React, { FC } from 'react';
import { Casino } from '../../../components/Games';
import { GameType } from '../../../components/Games/games.model';

type GameDetailsContentProps = {
  gameType?: GameType;
};

export const GameDetailsContent: FC<GameDetailsContentProps> = ({ gameType }) => {
  return (
    <>
      <Casino gameEnabled gameType={gameType} />
    </>
  );
};
